/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DriversList,
    DriversListFromJSON,
    DriversListToJSON,
    DriversMenuList,
    DriversMenuListFromJSON,
    DriversMenuListToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    StatusLogRequest,
    StatusLogRequestFromJSON,
    StatusLogRequestToJSON,
    VersionsResponse,
    VersionsResponseFromJSON,
    VersionsResponseToJSON,
} from '../models';

export interface GetDriversRequest {
    officeIds: Array<number>;
}

export interface SelectDriversMenuRequest {
    officeIds: Array<number>;
    planType: string;
    driverId?: number;
    officeId?: number;
}

export interface SendStatusLogRequest {
    statusLogRequest?: StatusLogRequest;
}

/**
 * 
 */
export class CommonApi extends runtime.BaseAPI {

    /**
     * 乗務員リストfor multiple offices
     */
    async getDriversRaw(requestParameters: GetDriversRequest): Promise<runtime.ApiResponse<DriversList>> {
        if (requestParameters.officeIds === null || requestParameters.officeIds === undefined) {
            throw new runtime.RequiredError('officeIds','Required parameter requestParameters.officeIds was null or undefined when calling getDrivers.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.officeIds) {
            queryParameters['office_ids'] = requestParameters.officeIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/offices/drivers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DriversListFromJSON(jsonValue));
    }

    /**
     * 乗務員リストfor multiple offices
     */
    async getDrivers(requestParameters: GetDriversRequest): Promise<DriversList> {
        const response = await this.getDriversRaw(requestParameters);
        return await response.value();
    }

    /**
     * API versions
     */
    async getversionsRaw(): Promise<runtime.ApiResponse<VersionsResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/versioninfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionsResponseFromJSON(jsonValue));
    }

    /**
     * API versions
     */
    async getversions(): Promise<VersionsResponse> {
        const response = await this.getversionsRaw();
        return await response.value();
    }

    /**
     * 乗務員リストメニュー
     */
    async selectDriversMenuRaw(requestParameters: SelectDriversMenuRequest): Promise<runtime.ApiResponse<DriversMenuList>> {
        if (requestParameters.officeIds === null || requestParameters.officeIds === undefined) {
            throw new runtime.RequiredError('officeIds','Required parameter requestParameters.officeIds was null or undefined when calling selectDriversMenu.');
        }

        if (requestParameters.planType === null || requestParameters.planType === undefined) {
            throw new runtime.RequiredError('planType','Required parameter requestParameters.planType was null or undefined when calling selectDriversMenu.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.officeIds) {
            queryParameters['office_ids'] = requestParameters.officeIds.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.driverId !== undefined) {
            queryParameters['driver_id'] = requestParameters.driverId;
        }

        if (requestParameters.officeId !== undefined) {
            queryParameters['office_id'] = requestParameters.officeId;
        }

        if (requestParameters.planType !== undefined) {
            queryParameters['plan_type'] = requestParameters.planType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/drivers_list_menu`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DriversMenuListFromJSON(jsonValue));
    }

    /**
     * 乗務員リストメニュー
     */
    async selectDriversMenu(requestParameters: SelectDriversMenuRequest): Promise<DriversMenuList> {
        const response = await this.selectDriversMenuRaw(requestParameters);
        return await response.value();
    }

    /**
     * send status log
     */
    async sendStatusLogRaw(requestParameters: SendStatusLogRequest): Promise<runtime.ApiResponse<object>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/logger`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StatusLogRequestToJSON(requestParameters.statusLogRequest),
        });

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * send status log
     */
    async sendStatusLog(requestParameters: SendStatusLogRequest): Promise<object> {
        const response = await this.sendStatusLogRaw(requestParameters);
        return await response.value();
    }

}
